import React, { memo } from 'react';

type IconProps = {
  className?: string;
  color?: string;
  size?: number;
};

export const DirectoryIcon = memo(({ className, size = 24 }: IconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 512 512">
      <g id="_18-medical-record-folder">
        <path d="M256,112h80v16h-80v-16Z" />
        <path d="M256,144h80v16h-80v-16Z" />
        <path d="M256,176h80v16h-80v-16Z" />
        <path d="M256,208h80v16h-80v-16Z" />
        <path d="M167,126.5c5.9,1.9,12.2,1.9,18,0,2.9,10.3,12.3,17.4,23,17.5h8c4.4,0,8,3.6,8,8v24h16v-24c0-13.3-10.7-24-24-24h-8c-4.4,0-8-3.6-8-8v-3.1c5.1-5.8,8-13.2,8-20.9v-16c0-17.7-14.3-32-32-32s-32,14.3-32,32v16c0,7.7,2.9,15.2,8,20.9v3.1c0,4.4-3.6,8-8,8h-8c-13.3,0-24,10.7-24,24v24h16v-24c0-4.4,3.6-8,8-8h8c10.7,0,20.1-7.2,23-17.5ZM160,80c0-8.8,7.2-16,16-16s16,7.2,16,16v16c0,8.8-7.2,16-16,16s-16-7.2-16-16v-16Z" />
        <path d="M264,96h64c4.4,0,8-3.6,8-8v-32c0-4.4-3.6-8-8-8h-64c-4.4,0-8,3.6-8,8v32c0,4.4,3.6,8,8,8ZM272,64h48v16h-48v-16Z" />
        <path d="M496,224c0-26.5-21.5-48-48-48h-48V56c0-4.4-3.6-8-8-8h-24v-24c0-4.4-3.6-8-8-8H88c-4.4,0-8,3.6-8,8v176h-24c-22.1,0-40,17.9-40,40v216c0,22.1,17.9,40,40,40h336c21.4,0,38.9-16.9,39.8-38.3l63.9-231.6c.2-.7.3-1.4.3-2.1ZM384,64v176h-16V64h16ZM96,32h256v208h-156.7l-37.7-37.7c-1.5-1.5-3.5-2.3-5.7-2.3h-56V32ZM416,456c0,13.3-10.7,24-24,24H56c-13.3,0-24-10.7-24-24h0v-216c0-13.3,10.7-24,24-24h92.7l37.7,37.7c1.5,1.5,3.5,2.3,5.7,2.3h200c13.3,0,24,10.7,24,24v176ZM432,396.9v-116.9c0-19-13.4-35.4-32-39.2v-48.8h48c17.3,0,31.4,13.7,32,31l-48,173.9Z" />
        <path d="M304,328h-40v-40c0-4.4-3.6-8-8-8h-64c-4.4,0-8,3.6-8,8v40h-40c-4.4,0-8,3.6-8,8v64c0,4.4,3.6,8,8,8h40v40c0,4.4,3.6,8,8,8h64c4.4,0,8-3.6,8-8v-40h40c4.4,0,8-3.6,8-8v-64c0-4.4-3.6-8-8-8ZM296,392h-40c-4.4,0-8,3.6-8,8v40h-48v-40c0-4.4-3.6-8-8-8h-40v-48h40c4.4,0,8-3.6,8-8v-40h48v40c0,4.4,3.6,8,8,8h40v48Z" />
      </g>
    </svg>
  );
});
